<template>
  <div class="sticky top-0 z-50 shadow-lg">
  <div class="banner-wrapper">
    <div class="banner-track">
      <router-link v-for="n in 12" :key="n" to="/plushie" class="banner-item">
        PLUSHIES <span class="banner-underline">OUT NOW</span>
        <span class="banner-star">★</span>
      </router-link>
    </div>
  </div>
    <nav class="bg-momo-secondary-blue text-momo-text-light">
      <div class="container mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center h-20">
        <router-link to="/" class="text-3xl" style="font-family: 'Monaz', cursive; color: var(--momo-text-light);">
          momo the cat
        </router-link>
  
        <ul class="hidden md:flex space-x-6 items-center" style="font-family: 'Open Sans', sans-serif;">
          <li v-for="item in menuItems" :key="item.key">
            <router-link :to="item.path" class="hover:text-momo-accent-yellow transition-colors duration-300 text-lg">
              {{ item.title }}
            </router-link>
          </li>
        </ul>
  
        <a 
          href="https://www.coinbase.com/price/momo-the-cat-solana-dycqssstijnk7azaypj5njulhw42pxd2ndejgw77pump-token" 
          target="_blank" 
          rel="noopener noreferrer"
          class="hidden md:inline-block py-2 px-6 rounded-full font-semibold transition-all duration-300 ease-in-out"
          style="background-color: var(--momo-accent-coral); color: var(--momo-text-light); font-family: 'Open Sans', sans-serif; border-radius: 20px; box-shadow: 0 4px 10px rgba(0,0,0,0.1); text-shadow: 0 1px 3px rgba(0,0,0,0.4);"
        >
          $momo is live!
        </a>
        <div class="md:hidden">
          <button @click="mobileMenuOpen = !mobileMenuOpen" class="focus:outline-none">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16m-7 6h7"></path>
            </svg>
          </button>
        </div>
      </div>
  
      <div v-if="mobileMenuOpen" class="md:hidden bg-momo-secondary-blue pb-4" style="font-family: 'Open Sans', sans-serif;">
        <ul class="flex flex-col items-center space-y-4">
          <li v-for="item in menuItems" :key="item.key" @click="mobileMenuOpen = false">
            <router-link :to="item.path" class="hover:text-momo-accent-yellow transition-colors duration-300 text-lg py-2 block">
              {{ item.title }}
            </router-link>
          </li>
          <li>
            <a 
              href="https://www.coinbase.com/price/momo-the-cat-solana-dycqssstijnk7azaypj5njulhw42pxd2ndejgw77pump-token"
              target="_blank" 
              rel="noopener noreferrer"
              @click="mobileMenuOpen = false"
              class="mt-2 inline-block py-2 px-6 rounded-full font-semibold transition-all duration-300 ease-in-out"
              style="background-color: var(--momo-accent-coral); color: var(--momo-text-light); border-radius: 20px; text-shadow: 0 1px 3px rgba(0,0,0,0.4);"
            >
              $momo is live!
            </a>
            </li>
        </ul>
      </div>
    </nav>
  </div>
  </template>
  
  <script setup lang="ts">
  import { ref } from 'vue';
  
  const mobileMenuOpen = ref(false);
  
  // Adapting menu items from your baseMenu.ts
  // You might want to centralize this data or fetch it if it's dynamic
  const menuItems = ref([
    // { title: 'Guide', key: 'guide', path: '/guide' }, // Example, update path as needed
    // { title: 'Video', key: 'video', path: '/video-assets' }, // Example
    // { title: 'Audio', key: 'audio', path: '/audio-assets' }, // Example
    // { title: 'Image', key: 'image', path: '/image-assets' }, // Example
    // The "Meme Generator" is handled by the CTA button and also included in mobile menu explicitly.
    // Add other main navigation links here if you have them.
    // For now, keeping it simple until we define more pages.
    // If you want to dynamically use baseMenu.ts, you'd import it and map it here.
  ]);
  
  // Example of how you might adapt your src/data/baseMenu.ts
  // import { menuData as rawMenuItems } from '@/data/baseMenu.ts';
  // const menuItems = ref(rawMenuItems.map(item => {
  //   if (item.key === 'text') { // Assuming 'text' was the key for 'Bop Cat' / Meme Generator
  //     return { title: 'Meme Generator', key: 'editor', path: '/editor' };
  //   }
  //   // Map other keys to actual paths
  //   if (item.key === 'local') return { title: 'Guide', key: 'guide', path: '/guide'};
  //   return { title: item.title, key: item.key, path: `/${item.key}` }; // Placeholder paths
  // }).filter(item => item.key !== 'editor')); // Remove duplicate editor link if CTA handles it for desktop
  // For simplicity, the above menuItems is static. You can make it dynamic.
  
  </script>
  
  <style scoped>
.banner-wrapper {
  background-color: var(--momo-accent-coral, #e05a4e);
  color: #fff;
  overflow: hidden;
  white-space: nowrap;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  font-size: 0.85rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
  padding: 8px 0;
}

.banner-track {
  display: inline-flex;
  animation: marquee 28s linear infinite;
}

.banner-item {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  color: #fff;
  text-decoration: none;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.banner-item:hover {
  opacity: 0.85;
}

.banner-underline {
  text-decoration: underline;
  text-underline-offset: 3px;
  margin-left: 0.35em;
}

.banner-link {
  color: #fff;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
}

.banner-link:hover {
  opacity: 0.8;
}

.banner-star {
  margin: 0 1.25rem;
  line-height: 1;
}

@keyframes marquee {
  0%   { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

  .momo-nav {
    /* Using CSS variables defined in main.css */
    background-color: var(--momo-secondary-blue);
    color: var(--momo-text-light);
  }
  
  /* Additional styling for hover effects on nav links if needed */
  nav ul li a:hover, nav ul li button:hover {
    /* color: var(--momo-accent-yellow); */ /* Already handled by Tailwind */
  }
  
  .container {
    max-width: 1280px; /* Adjust as per your full-width preference, or remove for true 100% width */
  }
  </style>